// src/components/onboarding/screens/FinalScreen.js
import React from 'react';
import { PrimaryButton } from '../OnboardingUI';

const FinalScreen = ({ userName, onStart }) => {
  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-gradient-to-b from-indigo-950/95 to-purple-900/90 rounded-3xl overflow-hidden border border-white/10 shadow-2xl shadow-black/50 p-6 flex flex-col items-center justify-center text-center min-h-[500px]">
        <div className="w-full max-w-[280px] aspect-video bg-gradient-to-br from-indigo-900 to-purple-900 rounded-2xl mb-6 flex flex-col items-center justify-center shadow-xl border border-purple-500/30">
          <div className="w-16 h-16 bg-gradient-to-br from-indigo-500 to-purple-500 rounded-full flex items-center justify-center mb-3 shadow-lg shadow-indigo-500/40">
            <span className="text-white text-3xl font-bold">N</span>
          </div>
          <p className="text-purple-400 text-sm">
            <video 
              className="w-full h-full object-cover"
              autoPlay 
              loop 
              muted 
              playsInline
            >
              <source src="/assets/lux-video-new.mp4" type="video/mp4" />
              Votre navigateur ne supporte pas la lecture de vidéos.
            </video>
          </p>
        </div>

        <h2 className="text-2xl font-bold text-gray-100 mb-2">
          Salut {userName} !
        </h2>
        <p className="text-gray-400 mb-1">
          Je suis Lux, ton coach orientation.
        </p>
        <p className="text-gray-500 text-sm mb-8">
          J'ai bien recu tes reponses - on va pouvoir avancer ensemble.
        </p>

        <PrimaryButton onClick={onStart}>
          Commencer avec Nox
        </PrimaryButton>
      </div>
    </div>
  );
};

export default FinalScreen;
